import React from "react"

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number
  color?: string
  title?: string
}

export const MdStarHalf: React.FC<IconProps> = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" />
    </svg>
  )
}

export default MdStarHalf
